module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0081.png.a260604d.jpg";